<ng-container *ngIf="replacingNameListForm !== undefined">
  <h3 mat-dialog-title i18n>Editing titles</h3>
  <mat-dialog-content>
    <eas-editor-booking-item-bulk-name-search-replace [namesReplaced]="namesReplaced" (searchAndReplace)="onSearchAndReplace($event)">
    </eas-editor-booking-item-bulk-name-search-replace>
    <form>
      <fieldset>
        <legend>
          <div>
            <span i18n>Single item edit</span>
          </div>
        </legend>
        <ng-container *ngFor="let formControl of replacingNameListForm.controls; let controlIndex = index">
          <div class="form-container" style="position: relative" [style.margin-left.px]="replacingBulkNameList[controlIndex].level * 30">
            <ng-container *ngFor="let levelLine of levelLinesList[controlIndex]; let levelLineIndex = index">
              <div *ngIf="controlIndex !== 0 && (levelLineIndex === replacingBulkNameList[controlIndex].level - 1 || levelLine)"
                style="
                  position: absolute;
                  border-left: 2px dashed gray;
                  top: 0;
                "
                [style.left.px]="-15 - 30 * (replacingBulkNameList[controlIndex].level - 1 - levelLineIndex)"
                [style.height]="levelLine ? '100%' : '15px'"
              >
              </div>
              <div *ngIf="controlIndex !== 0 && levelLineIndex === replacingBulkNameList[controlIndex].level - 1"
                style="
                  position: absolute;
                  top: 30px;
                  width: 40px;
                  padding: 3px 2px;
                  z-index: 10;
                  font-size: 16px;
                  background-color: white;
                "
                [style.left.px]="-20 - 15 - 30 * (replacingBulkNameList[controlIndex].level - 1 - levelLineIndex)"
              >
              </div>
            </ng-container>
            <div *ngIf="controlIndex !== 0" style="
              position: absolute;
              top: 15px;
              left: -15px;
              width: 15px;
              border-top: 2px dashed gray;
            ">
            </div>
            <mat-form-field appearance="outline">
              <mat-label i18n>Title</mat-label>
              <input matInput type="text" [formControl]="getFormControl(controlIndex)">
            </mat-form-field>
          </div>
        </ng-container>
      </fieldset>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button color="primary" [disabled]="replacingNameListForm.invalid" (click)="onSubmit()" i18n>Apply</button>
  </mat-dialog-actions>
</ng-container>
